export default class Alert {
  initializeListeners() {
    setTimeout(() => $('p.notice, p.alert, p.top_notice').addClass('fade-out'), 10000);
  }
}
